import { mapState } from "vuex";
import * as Graph from "../../libs/Graph";
import * as turf from "@turf/turf";
import * as randomPoint from "random-points-on-polygon";

export default {
	name: 'PathFinder',
	computed: {
		...mapState([
			"zones",
			"features",
			"stairs_vector",
			"workers",
			"worker_status",
			"vehicle_types",
			"debug"
		]),
		pathLayer() { return this.$store.state.map.pathLayer }
	},
	methods: {
		_getPath(asset, origin, target_zone_id) {

			let target_feature = this.features[target_zone_id];
			let target_zone = this.zones[target_zone_id];

			let destination = (target_feature.tool == 'MultiLineString') ? target_feature.getGeometry().getClosestPoint(asset.coordinates) : this.$geo.toOL(randomPoint(1, target_feature.turf)[0].geometry.coordinates);

			// console.log(target_feature.inner.geometry.coordinates);
			// short travel, if the distance between asset's zone and target zone is small, go in a straight line(?)
			//if (this.worker_status[worker.id].zone_id) {
			if (!this.$asset.isVehicle(asset)) {
				let current_zone = this.$worker.getRealZone(asset);
				if (current_zone) {

					let shortLine;
					let target_parking;
					let current_parking;

					var nodes = [];//{zone_id: current_zone.id}];
					if (asset.target_zone_id) nodes.push({zone_id: asset.target_zone_id});

					if (this.$worker.requiresTransportation(asset, nodes)) {
						target_parking = this.$zone.getClosestParking(target_zone, '*', 'transport');
						current_parking = this.$zone.getClosestParking(current_zone, '*', 'transport');
						if (target_parking.id == current_zone.id || target_parking.id == current_parking.id) {
							shortLine = this.$zone.zonesAreClose(asset.zone.id, target_zone_id, '*'); // * = any walking distance if the worker is at parking zone of the target zone
						}
					}
					else shortLine = this.$zone.zonesAreClose(asset.zone.id, target_zone_id);


					if (shortLine) {
						let route = shortLine.line.getCoordinates();//[origin];
						route.unshift(asset.coordinates);

						if (target_zone.floor_level != asset.floor_level) {

						//	let stairs = this.stairs_vector.getClosestFeatureToCoordinate(route[route.length - 1]);
							let stairs = this.stairs_vector.getClosestFeatureToCoordinate(origin);
							let stairsShortLine = this.$zone.zoneIsClose(stairs.id, origin);
							if (!stairsShortLine) {
								stairs = this.stairs_vector.getClosestFeatureToCoordinate(route[route.length - 1]);
								stairsShortLine = this.$zone.zoneIsClose(stairs.id, route[route.length - 1]);
							}
							if (!stairsShortLine) return [];

							let stairs_position = turf.pointOnFeature(stairs.turf);
							route.splice(route.length - 1, 0, this.$geo.toOL(stairs_position.geometry.coordinates));
						}

						asset.destination = route[route.length - 1];
						return route;
					}

				}
			}

			let Vector = new ol.source.Vector({});

			this.pathLayer.forEachFeature((Feature) => {
				Feature.getGeometry().getLineStrings().forEach((LineString) => {
					LineString.forEachSegment((a, b) => {
						let f = new ol.Feature({ geometry: new ol.geom.LineString( [a, b] ) });
						Vector.addFeature(f);
					});
				});
			});

			// create and split  that intersects with origin and destination points
			[origin, destination].forEach((coord, index) => {
				this.pathLayer.forEachFeature((Feature) => {
					let p1 = Feature.getGeometry().getClosestPoint(coord);
					let f = new ol.Feature({ geometry: new ol.geom.LineString( [coord, p1] ) });
					Vector.addFeature(f);
				});
			});

			let SegmentsSource = new ol.source.Vector({features: [...Vector.getFeatures()]});

			Vector.forEachFeature((Feature) => {
				Feature.getGeometry().getCoordinates().forEach((coord, index) => {
					let Point = new ol.geom.Point(coord);
					SegmentsSource.forEachFeatureIntersectingExtent(ol.extent.buffer(Point.getExtent(), 0.001), (FeatureCopy) => {

						if (Feature == FeatureCopy) return;
						SegmentsSource.removeFeature(FeatureCopy);
						let coord1 = [FeatureCopy.getGeometry().getFirstCoordinate(), coord];
						let coord2 = [FeatureCopy.getGeometry().getLastCoordinate(), coord];
						if (!this.$finder.is_equal(coord1[0], coord1[1])) SegmentsSource.addFeature(new ol.Feature({ geometry: new ol.geom.LineString(coord1) }));
						if (!this.$finder.is_equal(coord2[0], coord2[1])) SegmentsSource.addFeature(new ol.Feature({ geometry: new ol.geom.LineString(coord2) }));

					});
				});
			});



			let graph = {};
			SegmentsSource.forEachFeature((segment)=>{
				//segment.setStyle(new ol.style.Style({ 'stroke': new ol.style.Stroke({color: this.$finder.random([ 'green', 'yellow', 'red', 'pink', 'blue', 'purple', 'grey', 'orange']), width:4}) }))

				//this.overlayLayer.addFeature(segment);
				segment.getGeometry().getCoordinates().forEach((coord) => {
					let index = this.$geo.hashString(coord);
					let point = new ol.Feature({ geometry: new ol.geom.Point(coord) });
					//this.overlayLayer.addFeature(point);
					SegmentsSource.forEachFeatureIntersectingExtent(point.getGeometry().getExtent(), (f) => {
						let coord2 = f.getGeometry().getCoordinates();
					//	console.log(coord2);
						let other_end = (coord2[0] == coord[0]) ? coord2[coord2.length - 1] : coord2[0];
						let other_index = this.$geo.hashString(other_end);
						//let line = turf.lineString(this.$geo.toTurf(coord2));
						let distance = turf.distance(this.$geo.toTurf(coord), this.$geo.toTurf(other_end))// turf.length(line);

						if (!graph[index]) graph[index] = {};
						graph[index][other_index] = distance;

						if (!graph[other_index]) graph[other_index] = {};
						graph[other_index][index] = distance;
					})
				})
			});

			graph = new Graph(graph);
			let path = graph.findShortestPath(this.$geo.hashString(origin), this.$geo.hashString(destination));

			let route = [];
			path.forEach((coord) => {
				let coords = atob(coord).split(',');
				coords[0] = parseFloat(coords[0]);
				coords[1] = parseFloat(coords[1]);
				route.push(coords);
			});

			if (target_zone.floor_level != asset.floor_level) {

				let stairs = this.stairs_vector.getClosestFeatureToCoordinate(origin);
				let stairsShortLine = this.$zone.zoneIsClose(stairs.id, origin);
				if (!stairsShortLine) {
					stairs = this.stairs_vector.getClosestFeatureToCoordinate(route[route.length - 1]);
					stairsShortLine = this.$zone.zoneIsClose(stairs.id, route[route.length - 1]);
				}
				if (!stairsShortLine) return [];

				let stairs_position = turf.pointOnFeature(stairs.turf);
				route.splice(route.length - 1, 0, this.$geo.toOL(stairs_position.geometry.coordinates));
			}
			asset.destination = destination;
			return route;
		},
	}
}
